import categories from '@lba-dev/package.local-globals/categories';
import status from '@lba-dev/package.local-globals/iStatus';

import constants from '../../constants/collections';
import { Types } from './Types';

export const List = ({ users }) => ({
  default: {
    dataFormat: {
      table: {
        OS: Types.Text,
        Commercial: Types.Text,
        'Prise en charge': Types.Text,
        'Cat.': Types.Rectangle,
        Ajout: Types.Text,
        Client: Types.Text,
        Prevu: Types.Date,
        'Montant CEE': Types.Money,
        'Montant MPR': Types.Money,
        'Reste à charge': Types.RemainingCharge,
        Prix: Types.Money,
        iStatus: Types.Chip,
        'Statut Aides': Types.Text,
        'Sous statut': Types.Text,
      },
      tableData: [
        { class: 'th' },
        { class: '', list: users, key: 'login' },
        { class: '', list: users, key: 'login' },
        { class: '', list: categories.data },
        { class: 'reduce' },
        { class: '' },
        { class: 'reduce' },
        { class: '', key: 'ceeAmount' },
        { class: '', key: 'anahAmount' },
        { class: '', key: 'remainingCharge' },
        { class: '', key: 'announcedPrice' },
        { class: '', list: status.data },
        { class: '' },
        { class: '' },
      ],
      keys: [
        'id',
        'login.ajout',
        'login.caldeoPrisEnCharge',
        'categorie',
        'date.ajout',
        [
          'client.civility',
          'client.name',
          'client.firstname',
          'client.society',
        ],
        'date.intervention',
        'ceeAmount',
        'anahAmount',
        'remainingCharge',
        'announcedPrice',
        'status',
        'caldeo.mainStatus',
        'caldeo.subStatus',
      ],
      checkType: [
        'number',
        'users',
        'users',
        'categorie',
        'date',
        ['client.civility', 'client.name', 'client.firstname'],
        'date',
        'prix',
        'prix',
        'prix',
        'prix',
        'iStatus',
        'caldeo.mainStatus',
        'caldeo.subStatus',
      ],
    },
    listen: constants.interventions,
  },
});
